import { TAKE_ACTION_IMG_URLS } from 'src/app/pages/about/impact/shared/consts';

type Result = ModelHookResult<{
	pictures: Array<{ url: string; desktopOnly: boolean }>;
}>;

export function useGetPictures(): Result {
	return {
		data: {
			pictures: TAKE_ACTION_IMG_URLS,
		},
	};
}
